import React from 'react'
import "../../styles/imagePageStyles.css"

export default function Graduation() {
  const images = [
    require("../../images/graduation/graduation (1).jpg"),
    require("../../images/graduation/graduation (2).jpg"),
    require("../../images/graduation/graduation (3).jpg"),
    require("../../images/graduation/graduation (4).jpg"),
    require("../../images/graduation/graduation (5).jpg"),
    require("../../images/graduation/graduation (6).jpg"),
    require("../../images/graduation/graduation (7).jpg"),
    require("../../images/graduation/graduation (8).jpg"),
    require("../../images/graduation/graduation (9).jpg"),
    require("../../images/graduation/graduation (10).jpg"),
  ];
  return (
    <div className="graduation">

      <div className="images">
      {images.map((src, index) => (
        <img
          src={src}
          alt="graduation image"
        //   onClick={() => openImageViewer(index)}
          width="300"
          height={'300'}
          key={index}
          style={{ margin: "2px" }}
        />
      ))}
      </div>
      </div>
  )
}
